import { get$ } from "./default";
import { api } from "../constants/api";

export const searchOpportunitiesAPI = (q, opts = {}) => {
  const params = new URLSearchParams();
  if (q) params.set("q", q.trim());
  if (opts.page != null) params.set("page", String(opts.page));
  if (opts.page_size != null) params.set("page_size", String(opts.page_size));
  const query = params.toString();
  return get$(api.projects.search, query);
};
